export default __webpack_public_path__ + "static/media/kid06.8b846248.jpg";